import PropTypes from 'prop-types';

import { Button } from '@spotahome/ui-library';

import './CallToAction.scss';

const CallToAction = ({ href, text, onClick, className, color, dataTest }) => (
  <Button
    href={href}
    color={color}
    className={`call-to-action ${className || ''}`}
    target="_blank"
    size="big"
    onClick={onClick}
    data-test={dataTest}
  >
    {text}
  </Button>
);

CallToAction.defaultProps = {
  color: 'primary',
  className: '',
  onClick() {},
  dataTest: 'generic-call-to-action'
};

CallToAction.propTypes = {
  href: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  color: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  dataTest: PropTypes.string
};

export default CallToAction;
